export default {
  currentUserInfo: {},
  userInfo: JSON.parse(sessionStorage.getItem('currentUserInfo')) || {},
  allCompanyLists: JSON.parse(sessionStorage.getItem('allCompanyLists')) || [],
  currentSupplierId: localStorage.getItem('currentSupplierId') || '',
};
